import LeadPropertyProvider from './leadProperty'
import PropertyProvider from './property'
import UserProvider from './user'
import VisitProvider from './visits'
import RunnerProvider from './runners'
import EventProvider from './events'
import LeadInspectionProvider from './leadInspection'

const getProvider = (resource) => {
  switch (resource) {
    case 'leadProperties':
      return LeadPropertyProvider
    case 'properties':
      return PropertyProvider
    case 'users':
      return UserProvider
    case 'visits':
      return VisitProvider
    case 'runners':
      return RunnerProvider
    case 'events':
      return EventProvider
    case 'leadInspections':
      return LeadInspectionProvider
    default:
      console.error('No resource set, please set the new resource')
      return undefined
  }
}

const customDataProvider = {
  getList: (resource, params) => getProvider(resource)?.getList(resource, params),
  getOne: (resource, params) => getProvider(resource)?.getOne(resource, params),
  getMany: (resource, params) => getProvider(resource)?.getMany(resource, params),
  getManyReference: (resource, params) => getProvider(resource)?.getManyReference(resource, params),
  create: (resource, params) => getProvider(resource)?.create(resource, params),
  update: (resource, params) => getProvider(resource)?.update(resource, params),
  updateMany: (resource, params) => getProvider(resource)?.updateMany(resource, params),
  delete: (resource, params) => getProvider(resource)?.delete(resource, params),
  deleteMany: (resource, params) => getProvider(resource)?.deleteMany(resource, params),
}

export default customDataProvider
